import styles from '../../styles/UI/divider.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

export default function Divider() {
  return <div className={cx('divider-container')}></div>;
}
